import { Flex } from "@mantine/core";
import React, { useState, useEffect, useRef } from "react";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import ClearIcon from "@mui/icons-material/Clear";
import BackspaceIcon from "@mui/icons-material/Backspace";

export default function CategoriesSelect({
  setSearchTerm,
  categoriesData,
  searchTerm,
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const toggleRef = useRef(null);

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      !toggleRef.current.contains(event.target)
    ) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    console.log("click");
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="categories-select-wrapper">
      <Flex align="center" gap={2}>
        <button
          style={{
            background: "none",
            border: "none",
          }}
          ref={toggleRef}
          onClick={() => setIsDropdownOpen((prev) => !prev)}
          type="button"
        >
          <Flex
            gap={5}
            align="center"
            style={{
              fontSize: 12,
            }}
            ref={toggleRef}
          >
            <p
              style={{
                color: "rgb(184, 184, 184)",
              }}
            >
              Categories
            </p>
            <UnfoldMoreIcon
              style={{
                fontSize: 13,
                color: "rgb(184, 184, 184)",
              }}
            />
          </Flex>
        </button>
        <div
          onClick={() => setSearchTerm("")}
          style={{
            display: "grid",
            placeContent: "center",
          }}
        >
          <BackspaceIcon
            style={{
              fontSize: 15,
              color: searchTerm ? "rgb(255, 201, 26)" : "rgb(184, 184, 184)",
            }}
          />
        </div>
      </Flex>
      <div
        className="categories-dropdown-wrapper"
        hidden={!isDropdownOpen}
        ref={dropdownRef}
      >
        {categoriesData
          .concat({ label: "Uncategorized", value: "uncategorized" })
          ?.map((categ, i) => {
            const { label, value } = categ;
            return (
              <div
                onClick={() => setSearchTerm(label)}
                className="individual-category-wrapper"
                key={i}
              >
                <button
                  type="button"
                  style={{
                    background: "none",
                  }}
                >
                  {label}
                </button>
              </div>
            );
          })}
      </div>
    </div>
  );
}
